import { createSelector } from 'reselect';

const _scopedState = (state) => state.entities.exportTask;
const _byExportType = (state) => _scopedState(state).byExportType;

const _selectedExportType = createSelector(
  [_byExportType, (state, exportType) => exportType],
  (byExportType, exportType) => byExportType[exportType]
);

// ######################################################################################## //
// INPUT SELECTORS
// ######################################################################################## //

const exportPassword = (state, exportType) => _selectedExportType(state, exportType).exportPassword;

const activeTask = (state, exportType) => _selectedExportType(state, exportType).activeTask;

const exportError = (state, exportType) => _selectedExportType(state, exportType).exportError;

const count = createSelector(
  activeTask,
  ([activeTask, (state, exportType) => exportType], (task, exportType) => task(exportType).currentNumRows)
);

const isCurrentExportGenerating = (state, exportType) =>
  _selectedExportType(state, exportType).isCurrentExportGenerating;
const isCurrentExportComplete = (state, exportType) => _selectedExportType(state, exportType).isCurrentExportComplete;
const isCurrentExportFailed = (state, exportType) => _selectedExportType(state, exportType).isCurrentExportFailed;
const isInitialLoad = (state, exportType) => _selectedExportType(state, exportType).isInitialLoad;
const isLoading = (state, exportType) => _selectedExportType(state, exportType).isLoading;

export default {
  count,

  exportPassword,
  activeTask,
  exportError,
  isCurrentExportGenerating,
  isCurrentExportComplete,
  isCurrentExportFailed,
  isInitialLoad,
  isLoading,
};
